// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"469":"53f2baf1","496":"a9b1bc0b","743":"cf5a3ba8"}[chunkId] + ".chunk.js";
};